module.exports = __webpack_public_path__ + "static/media/AddText_02-12-08.10.59.2e5a5fdc.jpg";